import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import supportedLanguageIds, { SupportedLanguage } from 'lib/lexemes/supported-languages';

// See corresponding unit test for all the test cases
function Link(
    props: React.DetailedHTMLProps<
        React.AnchorHTMLAttributes<HTMLAnchorElement>,
        HTMLAnchorElement
    >,
) {
    const router = useRouter();
    let href = props.href || '';

    // Specific links to the base should be kept as is
    if (href === '/') {
        return <a {...props} href={href} />;
    }

    // trim trailing slash
    if (href.endsWith('/')) {
        href = href.substr(0, href.length - 1);
    }

    if (!href.startsWith('http')) {
        // If link doesn't start with http, log warning and convert to local link
        if (!(href.startsWith('/') || href === '#')) {
            console.warn('Invalid link. Must be a local or valid http link', href);
            href = `/${href}`;
        }

        // 1. If it's a local link
        // 2. There is a language in the url
        // 3. There is no language in the link
        // Then add it
        const language = getLanguageFromUrl(router ? router.asPath : '');
        if (language && !startsWithSupportedLanguage(href)) {
            href = `/${language}${href}`;
        }
    }

    return <a {...props} href={href} />;
}

Link.props = {
    href: PropTypes.string,
    'data-href': PropTypes.string,
    rel: PropTypes.string,
    title: PropTypes.string,
    target: PropTypes.string,
    classname: PropTypes.string,
};

export default Link;

export function getLanguageFromUrl(urlStr: string) {
    // Filter out empty and dynamic routes
    const split = urlStr
        .split('/')
        .filter((path) => path !== '')
        .filter((path) => !/\[.+?\]/.test(path));

    // extract language
    const splitPart = split.shift();
    if (splitPart && supportedLanguageIds.includes(splitPart as SupportedLanguage)) {
        return splitPart as SupportedLanguage;
    }

    return null;
}

function startsWithSupportedLanguage(url?: string) {
    if (!url) {
        return false;
    }

    return supportedLanguageIds.some((language) => url.startsWith(`/${language}/`));
}
